"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillTagSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const SkillTag_1 = require("@src/components/pages/profile/modules/resume/form/ApplicantProfileComponents/SkillTag");
const react_intl_1 = require("react-intl");
const icons_1 = require("@ant-design/icons");
const Api = __importStar(require("@src/api"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const normalize_string_1 = require("@src/helpers/normalize-string");
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const useAppMutation_1 = require("@src/hooks/useAppMutation");
const CustomSkillTagSelect = (0, styled_components_1.default)(elements_1.Select) `
	width: 100%;
	.ant-select-selector {
		padding: 0.25rem;
	}

	.ant-select-selection-overflow {
		gap: 0.25rem;
	}
`;
const AddExpressionButton = (0, styled_components_1.default)(elements_1.Button) `
	width: 100%;
	display: flex;
	align-items: center;
	padding: 0.25rem 0.75rem;
`;
const SpinnerWrapper = (0, styled_components_1.default)(elements_1.Spinner) `
	width: 100%;
`;
const SkillTagSelect = ({ value, defaultValue, onChange, maxTagCount, isSkillPrimary, maxTagTextLength, otherSelectedSkills, ...otherProps }) => {
    const [options, setOptions] = react_1.default.useState((value === null || value === void 0 ? void 0 : value.map(val => ({ value: val.id, label: val.name }))) || []);
    const [searchValue, setSearchValue] = react_1.default.useState('');
    const intl = (0, react_intl_1.useIntl)();
    const areOptionsEmpty = options.length === 0;
    const doesSelectedSkillsHitLimit = (value === null || value === void 0 ? void 0 : value.length) === maxTagCount;
    const shouldHideDropdown = (areOptionsEmpty && !searchValue) || doesSelectedSkillsHitLimit;
    const { mutateAsync: getSkillTagsSuggestions, isLoading, data: suggestions, } = (0, useAppMutation_1.useAppMutation)(Api.SkillTag.getSkillTagsSuggestions);
    const onSearch = async (searchText, skillTagsToFilter) => {
        const normalizedSearchText = searchText ? (0, normalize_string_1.normalizeStr)(searchText) : undefined;
        if (!normalizedSearchText) {
            setOptions([]);
            return;
        }
        getSkillTagsSuggestions({ searchText, selectedOptionsIds: skillTagsToFilter.map(skill => skill.id) });
    };
    const actualSkillTags = [...(value || []), ...(suggestions || [])];
    const onSelectChange = (ids) => {
        setSearchValue('');
        onChange === null || onChange === void 0 ? void 0 : onChange(ids.map(id => {
            if (typeof id === 'number') {
                return actualSkillTags.find(skillTag => skillTag.id === id);
            }
            return {
                id,
                name: id,
            };
        }));
        setOptions([]);
    };
    const debounceOnSearch = react_1.default.useCallback((0, debounce_1.default)(onSearch, 300), []);
    react_1.default.useEffect(() => {
        const optionsFormat = suggestions === null || suggestions === void 0 ? void 0 : suggestions.map(suggestion => ({
            value: suggestion.id,
            label: suggestion.name,
        }));
        setOptions(optionsFormat || []);
    }, [suggestions]);
    const addExpression = async () => {
        try {
            const trimmedSearchValue = searchValue.trim();
            if (!trimmedSearchValue) {
                setSearchValue('');
                return;
            }
            const matchedSkillTag = suggestions === null || suggestions === void 0 ? void 0 : suggestions.find(suggestion => (0, normalize_string_1.normalizeStr)(suggestion.name) === (0, normalize_string_1.normalizeStr)(trimmedSearchValue));
            let newOption = matchedSkillTag;
            if (!newOption) {
                newOption = { id: trimmedSearchValue, name: trimmedSearchValue };
            }
            const isTagAlreadySelected = Boolean([...(value || []), ...(otherSelectedSkills || [])].find(({ name }) => (0, normalize_string_1.normalizeStr)(name) === (0, normalize_string_1.normalizeStr)(newOption.name)));
            if (isTagAlreadySelected) {
                antd_1.notification.warning({
                    message: intl.formatMessage({
                        id: 'general.warning',
                    }),
                    description: intl.formatMessage({
                        id: 'profile.resume.skill.duplicate_skill_warning',
                    }),
                });
                setSearchValue('');
                return;
            }
            const alreadySelectedIds = (value === null || value === void 0 ? void 0 : value.map(skillTag => skillTag.id)) || [];
            onSelectChange([...alreadySelectedIds, newOption.id]);
        }
        catch (err) {
            console.error(err);
        }
    };
    return ((0, jsx_runtime_1.jsx)(CustomSkillTagSelect, { mode: "multiple", open: true, dropdownClassName: shouldHideDropdown ? 'hidden' : '', loading: isLoading, onSearch: inputTextValue => {
            let inputText = inputTextValue;
            const isInputTooLong = inputText.length > maxTagTextLength;
            if (inputText === ',') {
                return;
            }
            if (inputTextValue[inputTextValue.length - 1] === ',') {
                if (!doesSelectedSkillsHitLimit) {
                    addExpression();
                }
                else {
                    antd_1.notification.warning({
                        message: intl.formatMessage({ id: 'general.warning' }),
                        description: intl.formatMessage({ id: 'global.notification.maximum_skill_tags_reached' }),
                    });
                    setSearchValue('');
                }
                return;
            }
            if (inputText.includes(',')) {
                inputText = inputText.substring(0, inputText.indexOf(','));
            }
            if (isInputTooLong) {
                inputText = inputText.substring(0, maxTagTextLength);
            }
            setSearchValue(inputText);
            debounceOnSearch(inputText, [...(value || []), ...(otherSelectedSkills || [])]);
        }, searchValue: searchValue, tagRender: SkillTag_1.SkillTag, value: value === null || value === void 0 ? void 0 : value.map(val => val.name), defaultValue: defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.map(val => val.id), maxTagTextLength: maxTagTextLength, onChange: onSelectChange, filterOption: false, options: options, dropdownRender: menu => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [searchValue && ((0, jsx_runtime_1.jsx)(AddExpressionButton, { type: "text", size: "middle", className: "p-b-xs p-t-xs p-l-s p-r-s flex-row align-center", icon: (0, jsx_runtime_1.jsx)(icons_1.PlusOutlined, { className: "m-r-s" }), onClick: addExpression, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.tag_add_expression" }) })), !areOptionsEmpty && !isLoading && searchValue && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: menu }), isLoading && (0, jsx_runtime_1.jsx)(SpinnerWrapper, { size: "large", delay: 200 })] })), ...otherProps }));
};
exports.SkillTagSelect = SkillTagSelect;
